import Vue from 'vue'
import VueCardPayment from 'vue-card-payment'
import 'vue-card-payment/dist/vue-card-payment.css'


Vue.use(VueCardPayment)